import { render, staticRenderFns } from "./payadvanceOil.vue?vue&type=template&id=38a70ad2&scoped=true"
import script from "./payadvanceOil.vue?vue&type=script&lang=js"
export * from "./payadvanceOil.vue?vue&type=script&lang=js"
import style0 from "./payadvanceOil.vue?vue&type=style&index=0&id=38a70ad2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a70ad2",
  null
  
)

export default component.exports